/**
 * modal.js
 */

define(
        "modal",
        ['jquery', 'bootstrap'],
        function ($) {

            /**
             * Affichage d'une fenêtre modal avec un contenu dynamique
             * @param {string} url URL de la page contenue
             * @param {string} titre Titre de la fenêtre modal
             */
            function openModalIframe(url, titre, forChart)
            {
                $('#modalIframe').text('');
                $('#modalIframeLabel').text(titre);
                $('#modalIframe').hide();
                $('#loadingModalIframe').show();
                var firstChild = $('#modalIframeContent').children()[0];
                var littleChild = $('#modalIframeContent').children().children()[0];
                if (forChart === 'true' && typeof forChart !== 'undefined') {
                    $(firstChild).css("height", "100%");
                    $(firstChild).css("width", '100%');
                    $(firstChild).css("padding", "0");
                    $(firstChild).css("margin", "0");
                    $(littleChild).css("min-height", "100%");
                } else {
                    $(firstChild).removeAttr('style');
                    $(littleChild).removeAttr('style');
                }
                $('#modalIframeContent').modal('show');
                $('#modalIframe').load(url);
                $('#loadingModalIframe').hide();
                $('#modalIframe').show();
            }

            //    exposed public method
            return {
                openModalIframe: openModalIframe
            };
        },
        function (err) {
            console.error("ERROR: ", err.requireType);
            console.error("MODULES: ", err.requireModules);
        }
);

